import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { Modal } from '@madeeasy/universal-login';
import PropTypes from 'prop-types';
import { ToastContext } from '../../contexts/toast-context-with-provider';
import { useUser } from '../../contexts/ssr-user-context';
import CREATE_CALL_REQUEST from '../../gql/mutations/counselling.gql';
import Popup from './Popup';
import Spinner from '../../icons/spinner';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';

function EnrollForm({ user, requestCallBackEnroll }) {
  const [formData, setFormData] = React.useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    requestCallBackEnroll();
  };

  return (
    <form onSubmit={handleSubmit} className="lg:w-[350px] w-full space-y-4">

      <div>
        <label htmlFor="enroll-name" className="block text-sm font-medium mb-1">
          Full Name
          <input
            id="enroll-name"
            type="text"
            name="name"
            value={formData.name}
            readOnly
            onChange={handleChange}
            className="w-full border p-2 rounded mt-1"
          />
        </label>
      </div>

      <div>
        <label htmlFor="enroll-email" className="block text-sm font-medium mb-1">
          Email Address
          <input
            id="enroll-email"
            type="email"
            name="email"
            value={formData.email}
            readOnly
            onChange={handleChange}
            className="w-full border p-2 rounded mt-1"
          />
        </label>
      </div>

      <div>
        <label htmlFor="enroll-phone" className="block text-sm font-medium mb-1">
          Phone Number
          <input
            id="enroll-phone"
            type="tel"
            name="phone"
            value={formData.phone}
            readOnly
            onChange={handleChange}
            className="w-full border p-2 rounded mt-1"
          />
        </label>
      </div>

      <button
        type="submit"
        className="w-full bg-customBlue text-white p-2 rounded"
      >
        Submit
      </button>

    </form>
  );
}
function HtmlSnippet({ entityId, entityType, postLoginAction }) {
  // login popup
  const [showLogin, setShowLogin] = useState(false);
  const { showToast } = useContext(ToastContext);
  const toggleModal = () => {
    setShowLogin(false);
  };
  const { user } = useUser();
  const searchParams = useSearchParams();
  const router = useRouter();
  const callBackRequest = searchParams.get('callBackRequest');
  // eslint-disable-next-line no-unused-vars
  const [createCounselling, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_CALL_REQUEST);

  const { miscellaneousData } = useMiscellaneousData();
  const [formLoader, setFormLoader] = useState(false);
  const [showFormPopup, setShowFormPopup] = useState(false);
  const openLoginform = () => {
    if (postLoginAction === 'requestCallBack') {
      const isPrefixed = process.env.NEXT_PUBLIC_USE_BASE_PATH === 'true';
      const targetPath = isPrefixed ? `/prep${router.asPath}` : router.asPath;
      // const targetPath = `/prep${router.asPath}`;

      const redirectUrl = new URL(
        `https://${miscellaneousData?.hostname}${targetPath}`,
      );

      redirectUrl.searchParams.set('callBackRequest', 'true');

      const params = new URLSearchParams(searchParams.toString());
      params.set('redirectTo', redirectUrl.toString());

      const newUrl = `${window.location.pathname}?${params.toString()}`;

      window.history.replaceState(null, '', newUrl);
    }
    // setFormLoader(true); // loader ON
    setShowLogin(true);
  };

  const requestCallBackEnroll = () => {
    if (user?.id) {
      try {
        const result = createCounselling({
          variables: {
            input: {
              entityId,
              entityType,
              name: user?.name,
              mobile: user?.phone,
              email: user?.email,
            },
          },
        });
        if (result) {
          showToast('Counselling request submitted successfully!');
          setShowFormPopup(false);
          // Remove query params
          router.replace(router.asPath.split('?')[0], undefined, { shallow: true });
          // redirectToThankYou();
        }
      } catch {
        // mutation failed silently
      }
      setShowLogin(false);
    } else {
      openLoginform();
    }
  };
  useEffect(() => {
    const handleClick = (e) => {
      const enrollButton = e.target.closest('.enroll-now-react');
      console.log('postLoginAction:', postLoginAction);
      if (enrollButton) {
        if (user?.id) {
          if (postLoginAction === 'requestCallBack') {
            setShowFormPopup(true);
          }
        } else {
          openLoginform();
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [user]);
  // ---end-----

  useEffect(() => {
    if (callBackRequest === 'true' && user?.id) {
      setShowFormPopup(true);
    // setFormLoader(false);
    }
  }, [callBackRequest]);
  useEffect(() => {
    const handleLoginSuccess = () => {
      setFormLoader(true);
    };

    window.addEventListener('loginSuccess', handleLoginSuccess);

    return () => {
      window.removeEventListener('loginSuccess', handleLoginSuccess);
    };
  }, []);
  const handleCloseFormPopup = () => setShowFormPopup(false);
  const enrollFormContent = (
    <EnrollForm user={user} requestCallBackEnroll={requestCallBackEnroll} />
  );
  return (
    <>
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
      <Popup
        showPopup={showFormPopup}
        messageData={enrollFormContent}
        popupFor="MyCourse"
        onPopupClose={handleCloseFormPopup}
        batchHeading="Request a call Back"
        divwidth="!max-w-[63%] lg:w-auto w-full"
      />
      {formLoader && (
      <div className="fixed inset-0 top-0 flex items-center justify-center bg-black/30 z-40">
        <Spinner />
      </div>
      )}
    </>
  );
}
EnrollForm.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  requestCallBackEnroll: PropTypes.func.isRequired,

};
HtmlSnippet.propTypes = {
  entityId: PropTypes.string,
  entityType: PropTypes.string,
  postLoginAction: PropTypes.string,
};

export default HtmlSnippet;
